'use client';

import { useState, useRef, useEffect, Fragment } from "react";

import { getQueryFn } from "../../utils/api/queryFunction";
import { hasProperty } from "../../utils/validate";
import { addDataLayerEvent } from "../../utils/data.layer.utils/data.layer.util";
import { pickDataForPDPGTM } from "../../utils/data.layer.utils/pdp.data.layer.util";

import SEO from "../../components/Shared/SEO";
import ProductLayout from "../../components/Layout/ProductLayout";
import SubHeader from "../../components/Header/SubHeader";

import ProductBanner from '../../components/Shared/Banners/ProductBanner';

import ProductBuilder from "../../components/Shared/Builders/ProductBuilder";
import SideNav from "../../components/Shared/SideNav";

import Modal from "../../components/Molecules/Modal";
import FormHolder from "../Organisms/Forms/FormHolder";

const ProductDisplayPage = (props) => {
	const { category, data } = props;
	const [openBATD, setOpenBATD] = useState(false);
	const [formData, setFormData] = useState();

	// const [formSideNavHandle, setFormSideNavHandle] = useState();
	const [windowLocation, setWindowLocation] = useState();
	const banner = useRef();

	const enableSideNav = Array.isArray(data.sideNav) && data.sideNav.length > 0 ? true : false;

	const getFormData = async (formHandle) => {
		await getQueryFn(`form/${formHandle}`).then((res) => {
			setFormData(res);
		});
	}

	useEffect(() => {
		if (hasProperty(data, "hashtagActions") && Array.isArray(data.hashtagActions)) {
			Array(data.hashtagActions).forEach((action) => {
				if (Array.isArray(action) && action.length > 0) {
					action.forEach((attribute) => {
						if (attribute.action == "openFormModal" && window.location.hash == `${attribute.hashtag}`) {
							getFormData(attribute.value);
							setWindowLocation(window.location);
							const noHashURL = window.location.href.replace(/#.*$/, "");
							window.history.replaceState("", document.title, noHashURL);
						}
					});
				}
			});
		}

		addDataLayerEvent("ProductDisplayPage", pickDataForPDPGTM(category, data.slug));
	}, [data]);

	useEffect(() => {
		if (formData && windowLocation) {
			setOpenBATD(true);
		}
	}, [formData, windowLocation]);

	const pickDataValuesForFormMadalGTM = (data, formData) => {
		return {}
	}

	useEffect(() => {
		if (openBATD) {
			addDataLayerEvent(
				"FormModalOpen",
				pickDataValuesForFormMadalGTM(data, formData)
			);
		}
	}, [openBATD]);

	const getSubNav = (builder) => {
		let subNav = [];
		if (builder) {
			builder.forEach((item, index) => {
				if (item && item.data && hasProperty(item.data, "hasNavListing") && item.data.hasNavListing && hasProperty(item.data, "navTitle") && item.data.navTitle) {
					subNav.push({
						id: index,
						title: item.data.navTitle,
					});
				}
			});
		}

		return subNav;
	};

	return (
		<Fragment>
			<SEO seo={data.seo} />
			<ProductLayout
				// Override so no icon set imports are performed - import icons manually
				includeIconImport={false}
				nav={data.nav.header.links}
				logo={data.nav.header.logos[category]}
				root={category}
				footer={data.nav.footer}
			>
				{/* Insert Banner here */}
				<ProductBanner
					pageData={data}
					category={category}
					slug={data.slug}
					banner={data.banner}
					product={data.title}
					setOpenBATD={setOpenBATD}
					getFormData={getFormData}
					refElement={banner}
				/>
				{/* Build Navigation */}
				<SubHeader
					nav={getSubNav(data.builder)}
					refElement={banner}
				/>

				{enableSideNav && //length > 0 dont show button
					// <SideNav navItems={pageData.sideNav} />
					<SideNav
						category={category}
						slug={data.slug}
						navItems={data.sideNav}
						setOpenBATD={setOpenBATD}
						getFormData={getFormData}
					/>
				}

				<div className="productBuilderHolder">
					<div className="productBuilder">
						<ProductBuilder
							data={data}
							builder={data.builder}
							category={category}
							slug={data.slug}
							setOpenBATD={setOpenBATD}
							getFormData={getFormData}
						/>
					</div>
				</div>

				{openBATD && formData &&
					<Modal
						isActive={openBATD}
						title={data.batd.modalTitle ? data.batd.modalTitle : "Book a test drive"}
					>
						<FormHolder
							category={data.category}
							product={data.batd}
							models={data.batd.models}
							close={setOpenBATD}
							formData={formData}
							featuredImage={
								data.batd.models[data.batd.models.length - 1]
									? data.batd.models[
										data.batd.models.length - 1
									].featureImage
									: null
							}
							title={
								data.batd.modalTitle
									? data.batd.modalTitle
									: "Book a test drive"
							}
						/>
					</Modal>
				}
			</ProductLayout>
		</Fragment>
	);
};

export default ProductDisplayPage;